export default __webpack_public_path__ + "static/media/next-inactive.1c0bc2e4.svg";